import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { FormControlsModule } from '@anecdotes/design-system/form-controls';
import { BulkActionsComponent } from './components';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, TranslateModule, FormControlsModule, FormsModule, ButtonsModule, SvgIconsModule],
  declarations: [BulkActionsComponent],
  exports: [BulkActionsComponent],
})
export class BulkActionsModule {}
